var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    x: "0px",
    y: "0px",
    viewBox: "0 0 649.9 479.8",
    style: {
      enableBackground: "new 0 0 649.9 479.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "635.4,67.9 576.5,8.7 234.7,348.6 78.5,177.6 16.9,233.9 230.7,468 ",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkSm);
export default __webpack_public_path__ + "static/media/checkmark-sm.de7c0eb7f6f587235b48c5cbac3cbadf.svg";
export { ForwardRef as ReactComponent };